import { Injectable } from '@angular/core';
import { AngularFirestore, AngularFirestoreDocument } from '@angular/fire/compat/firestore';
import { AngularFireStorage, AngularFireUploadTask, AngularFireStorageReference } from '@angular/fire/compat/storage';
import { AngularFireFunctions } from '@angular/fire/compat/functions';
import { News } from '../models/news';
import { Observable } from 'rxjs';
import { SnackBarIconService } from '../shared/snack-bar-icon/snack-bar-icon.service';
import { finalize } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class NewsService {

  public spinner: boolean = false;

  public objectImage: any = null;
  public storedImage: any;

  public objectImage_en: any = null;
  public storedImage_en: any;

  private itemDoc: AngularFirestoreDocument<News>;
  private item: Observable<News>;

  constructor(
    private db: AngularFirestore,
    private fs: AngularFireStorage,
    private ff: AngularFireFunctions,
    private snackBar: SnackBarIconService) { }

  select() {
    return this.db.collection<News>('sbccv_news', ref => ref.orderBy('title', 'asc')).snapshotChanges();
  }

  selectById(id) {
    this.itemDoc = this.db.doc<News>('sbccv_news/' + id);
    this.item = this.itemDoc.valueChanges();
    return this.item;
  }

  insert(entity: News) {
    delete entity.id;
    return this.db.collection('sbccv_news').add(Object.assign({}, entity));
  }

  update(entity: News) {
    let id = entity.id;
    delete entity.id;
    return this.db.collection('sbccv_news').doc(id).set(Object.assign({}, entity));
  }

  remove_image(id: any, path_image: News) {
    return this.db.collection('sbccv_news').doc(id).set(path_image, { merge: true });
  }

  delete(entity_id: any) {
    return this.db.collection('sbccv_news').doc(entity_id).delete();
  }

  makeMsgError(errorsCode) {
    let msgError: string
    switch (errorsCode) {
      case "auth/email-already-exists":
        msgError = "Este email já está em uso"
        break;
    }
    return msgError
  }

  previewImage(event) {

    if (event.target.files.length === 0)
      return;

    var mimeType = event.target.files[0].type;
    if (mimeType.match(/image\/*/) == null) {
      this.snackBar.openSnackBar("Apenas arquivos .png", '', 'info');
      return;
    }

    var reader = new FileReader();
    this.objectImage = event.target.files[0];
    reader.readAsDataURL(event.target.files[0]);
    reader.onload = (_event) => {
      this.storedImage = reader.result;
      return event.target.files[0];
    }
  }

  previewImage_en(event) {

    if (event.target.files.length === 0)
      return;

    var mimeType = event.target.files[0].type;
    if (mimeType.match(/image\/*/) == null) {
      this.snackBar.openSnackBar("Apenas arquivos .png", '', 'info');
      return;
    }

    var reader = new FileReader();
    this.objectImage_en = event.target.files[0];
    reader.readAsDataURL(event.target.files[0]);
    reader.onload = (_event) => {
      this.storedImage_en = reader.result;
      return event.target.files[0];
    }
  }

  uploadImage(file, news_id) {
    const fsRef: AngularFireStorageReference = this.fs.ref("images/news/" + news_id + "_pt" + ".png");
    const fsTask: AngularFireUploadTask = fsRef.put(file);

    fsTask.snapshotChanges().pipe(
      finalize(() => {
        fsRef.getDownloadURL().subscribe(url => {
          this.updateImage(news_id, url)
        });
      }))
      .subscribe();
  }

  uploadImage_en(file, news_id) {
    const fsRef: AngularFireStorageReference = this.fs.ref("images/news/" + news_id + "_en" + ".png");
    const fsTask: AngularFireUploadTask = fsRef.put(file);

    fsTask.snapshotChanges().pipe(
      finalize(() => {
        fsRef.getDownloadURL().subscribe(url => {
          this.updateImage_en(news_id, url)
        });
      }))
      .subscribe();
  }

  updateImage(news_id: any, image: any) {
    return this.db.collection('sbccv_news').doc(news_id).set({ image: image }, { merge: true })
      .then(() => {
        this.objectImage = ""
        this.snackBar.openSnackBar("Sucesso!", '', 'success');
      })
      .catch((err) => {
        console.log("erro upadate image: " + JSON.stringify(err))
      })
      .finally(() => {
        this.spinner = false;
      })
  }

  updateImage_en(news_id: any, image_en: any) {
    return this.db.collection('sbccv_news').doc(news_id).set({ image_en: image_en }, { merge: true })
      .then(() => {
        this.objectImage_en = ""
        this.snackBar.openSnackBar("Sucesso!", '', 'success');
      })
      .catch((err) => {
        console.log("erro upadate image_en: " + JSON.stringify(err))
      })
      .finally(()=>{
        this.spinner = false;
      })
  }

}

